// extracted by mini-css-extract-plugin
export var root = "SS82";
export var rootHeading = "HE4C";
export var rootItem = "+668";
export var rootItemHeading = "bDGA";
export var rootItemImage = "Q6x8";
export var rootItemLink = "_2MNQ";
export var rootItemPicture = "IV6M";
export var rootItems = "mjMD";
export var rootSecondary = "LkJu";
export var rootTab = "_4t3q";
export var rootTabActive = "aU1W";
export var rootTabList = "_3VQ3";